import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SearchComponent } from './pages/search/search.component';
import { ViewComponent } from './pages/view/view.component';
import {FormsModule} from "@angular/forms";
import {TopBarComponent} from "./layout/top-bar/top-bar.component";

@NgModule({
  declarations: [
    AppComponent,
    SearchComponent,
    ViewComponent,
    TopBarComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }

export type TransportResponse = {
  statusCode: number,
  statusMessage: string,
  transport: Transport
}

export type Transport = {
  id: number,
  transportNumber: string,
  incoterm: string,
  loadingPlace: string,
  loadingUn2: string,
  deliveryPlace: string,
  deliveryUn2: string,
  totalVolume: number,
  totalWeight: number,
  events: TransportEvent[]
  packages: Package[]
}

export type TransportEvent = {
  description: string,
  endDate: string | null,
  endTime: string | null,
  expected: boolean,
  icon: string,
  id: number,
  isDone: boolean,
  isInProgress: boolean,
  name: string,
  order: number,
  startDate: string,
  startTime: string | null
}

export type Package = {
  amount: number,
  name: string,
  short: string
}

export type AuthResponse = {
  config: any,
  data: {
    access_token: string,
    expires_in: number,
    token_type: string
  },
  headers: any,
  request?: any,
  status: number,
  statusText: string
}

export type Auth = {
  accessToken: string,
  tokenType: string,
}
